__turbopack_context__.v({
  "channels": "xZFebG_channels",
  "container": "xZFebG_container",
});
